export interface IMinimalPerson {
  id: string
  name: string
  displayName?: string
}

export interface ISafetyTeamDocument {
  name: string
  storageName: string
  sizeInBytes: number
  fullPath: string
}

export interface ISafetyTeamRecord {
  id: string
  driver: IMinimalPerson | null
  driversLicenseNumber: string
  driverType: string
  testDate: string
  assignedDate: string
  documents: ISafetyTeamDocument[]
  archivedDate: string
  isEditing: boolean
}

export const TABLE_HEADERS = [
  'Driver',
  'Drivers License Number',
  'Driver Type',
  'Test Date',
  'Assigned Date',
  'Documents',
  'Archived Date',
  'Action',
]

export const DRIVER_TYPES = ['Commercial', 'Personal', 'CDL', 'Other']

